// English fallbacks for the translatable system default titles the API ships
// as title_key (config/locales/tournaments2/leaderboard/en.yml is the source
// of truth for the key paths) - used only when window.I18n is absent, per
// the module convention of a hardcoded English fallback on every t() call.
const DEFAULT_TITLES_BY_KEY = {
  'tournaments2.leaderboard.columns.position': 'Pos',
  'tournaments2.leaderboard.columns.player': 'Player',
  'tournaments2.leaderboard.columns.players': 'Players',
  'tournaments2.leaderboard.columns.teams': 'Teams',
  'tournaments2.leaderboard.columns.thru': 'Thru',
  'tournaments2.leaderboard.columns.total': 'Total',
  'tournaments2.leaderboard.columns.total_gross': 'Total<br>Gross',
  'tournaments2.leaderboard.columns.total_net': 'Total<br>Net',
  'tournaments2.leaderboard.columns.to_par_gross': 'To Par<br>Gross',
  'tournaments2.leaderboard.columns.to_par_net': 'To Par<br>Net',
  'tournaments2.leaderboard.columns.total_to_par_gross': 'Total<br>To Par<br>Gross',
  'tournaments2.leaderboard.columns.total_to_par_net': 'Total<br>To Par<br>Net',
  'tournaments2.leaderboard.columns.purse': 'Purse',
  'tournaments2.leaderboard.columns.points': 'Points',
  'tournaments2.leaderboard.columns.details': 'Details',
};

// A column's display title. titleText wins: the column was overwritten by
// the league or is league-named data, rendered verbatim (escaping is the
// renderer's job - see renderColumnTitle). Otherwise titleKey names a
// translatable system default, resolved in the viewer's locale.
export const resolveColumnTitle = (column) => {
  if (!column) return '';
  if (column.titleText) return column.titleText;
  if (!column.titleKey) return '';

  return !window.I18n
    ? (DEFAULT_TITLES_BY_KEY[column.titleKey] ?? '')
    : window.I18n.t(column.titleKey);
};

// The column the league's "hide purse from public leaderboard displays"
// option removes from portal views - the purse alone, like the legacy CSS
// (td.purse / th.purse / tr.total_purse_allocated); points stay visible.
export const PURSE_COLUMN_IDS = Object.freeze(['purse']);

export const withoutPurseColumns = (columns) =>
  (columns ?? []).filter((column) => !PURSE_COLUMN_IDS.includes(column.id));
